import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5D5300",
      d: "M13.03 13.03h-2.5v-7.5h2.5m-2.5 10h2.5v2.5h-2.5M16.441.53H7.117L.529 7.116v9.325l6.588 6.587h9.325l6.587-6.587V7.117z"
    }, null, -1)
  ]))]))
}
export default { render: render }